import { render, staticRenderFns } from "./BrokerTip.vue?vue&type=template&id=4ec730fc&scoped=true"
import script from "./BrokerTip.vue?vue&type=script&lang=js"
export * from "./BrokerTip.vue?vue&type=script&lang=js"
import style0 from "./BrokerTip.vue?vue&type=style&index=0&id=4ec730fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec730fc",
  null
  
)

export default component.exports